/**
 * Work Time Datasource
 *
 * @module modules/workTime/infrastructure/datasources/workTimeDatasource
 *
 * Handles API communication for work time status management.
 */

import { get, post } from '@/shared/api';

import type {
  WorkTime,
  WorkTimeType,
  UpdateWorkTimeRequest,
  UpdateWorkTimeResponse,
  UserStatusResponse,
} from '../../domain/types';

// ============================================================================
// Datasource
// ============================================================================

/**
 * Work Time Datasource
 *
 * Provides methods for fetching and updating work time status.
 */
export const workTimeDatasource = {
  /**
   * Get current work time status from user endpoint
   *
   * @returns Current work time status
   */
  async getWorkTime(): Promise<WorkTime> {
    const response = await get<UserStatusResponse>('/app/me');

    return {
      type: response.status || 'offline',
      updatedAt: new Date(),
    };
  },

  /**
   * Update work time status
   *
   * @param newStatus - The new work time status to set
   * @returns Updated work time status
   */
  async updateWorkTime(newStatus: WorkTimeType): Promise<WorkTime> {
    const request: UpdateWorkTimeRequest = {
      state: newStatus,
    };

    const response = await post<UpdateWorkTimeResponse>('/app/me/status', request);

    return {
      type: response.status,
      updatedAt: new Date(),
    };
  },
};
